var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"line-chart1",attrs:{"viewBox":_vm.viewBox}},[_c('g',{attrs:{"transform":"translate(30, 10)"}},[_c('path',{staticClass:"line-chart__line",attrs:{"d":_vm.line}})])])}
var staticRenderFns = []

export { render, staticRenderFns }